import { Pipe, PipeTransform } from '@angular/core';
import { PatientDetailsV2 } from '@ffd/api-client';
import { Person } from '@libs/ui-lib';

@Pipe({ name: 'libPatientsToPersons', pure: true, standalone: true })
export class PatientToPersonPipe implements PipeTransform {
  public transform(patients: PatientDetailsV2[]): Person[] {
    return patients.map((patient) => ({
      firstName: patient.firstName,
      lastName: patient.lastName,
      avatarUrl: null,
    }));
  }
}
